const isDomain = () =>
  !window.origin.includes('sites.icasei.com.br') &&
  !window.origin.includes('localhost')

export default isDomain
